<div class="sh-form-tag-list">
    <div class="sh-form-tag-list__input" (shClickOutside)="closeDroppanel()">
        <div
            *ngIf="addActionItem$ | async as actionItem"
            class="sh-input-field-with-action"
            [class.-sh-joined-action]="actionItem.location === actionLocation.Joined"
        >
            <div class="sh-input-field-with-action__input">
                <div class="sh-form-multiselect">
                    <div style="display: flex">
                        <!-- Used for adding dropdown for search-bar mode selection for example -->
                        <ng-content></ng-content>

                        <ng-container *ngIf="styling.style === formTagListStyle.Embedded; then tagList; else inputField"></ng-container>
                    </div>
                    <ng-container *ngTemplateOutlet="suggestions"></ng-container>
                </div>
            </div>
            <sh-action-item *ngIf="actionItem.location !== actionLocation.None" [item]="actionItem" class="sh-input-field-with-action__action"></sh-action-item>
        </div>

        <p *ngIf="(hasDuplicateInput$ | async) && duplicateErrorMsg !== ''" class="sh-form-group__feedback">{{ duplicateErrorMsg }}</p>
        <p *ngIf="invalid" [id]="describeLabelId" class="sh-form-group__feedback">{{ errorMsg }}</p>
        <p *ngIf="isIndeterminate$ | async" class="sh-form-group__feedback">{{ indeterminateMsg }}</p>
    </div>
    <ng-container *ngIf="styling.style !== formTagListStyle.Embedded; then tagList"></ng-container>
</div>

<ng-template #inputField>
    <input
        #searchInput
        type="text"
        [formControl]="tagInputControl"
        [id]="id"
        class="sh-input-field sh-form-group__input"
        [class.sh-form-tag-list__inline-input__input-field]="styling.style === formTagListStyle.Embedded"
        [class.-sh-remove-border]="styling.modifiers.indexOf(formTagListStyleModifier.NoBorder) >= 0"
        (keydown.enter)="onEnter($event)"
        (keyup.backspace)="onBackspace()"
        [attr.placeholder]="placeholder || null"
        [attr.aria-describedBy]="invalid ? describeLabelId : null"
        [attr.aria-invalid]="invalid"
        [attr.autocomplete]="autocomplete"
        [attr.disabled]="disabled ? true : null"
        [maxlength]="_maxLength"
        (focus)="onSearchFocus()"
    />
</ng-template>

<ng-template #tagList>
    <ul
        [id]="id + '-tag-list'"
        class="sh-tag-list"
        [class.sh-form-tag-list__list]="styling.style !== formTagListStyle.Embedded"
        [class.sh-form-tag-list__list--inline-input]="styling.style === formTagListStyle.Embedded"
    >
        @for (tag of filteredState$ | async; let i = $index; track tag.value) {
            @if (currentTagEditIndex !== i) {
                <li
                    [id]="id + '-tag-list-tag-' + i"
                    class="sh-tag sh-tag-list__item -sh-truncate"
                    [class]="styling.color"
                    [title]="tag.value"
                    [class.sh-tag--readonly]="disabled"
                    [class.-sh-editable]="editable"
                    (click)="onEditMode(i, tag.value)"
                    (keydown.enter)="onEditMode(i, tag.value)"
                >
                    <span class="sh-tag__label">{{ tag.value }}</span>
                    <button
                        #tagItem
                        *ngIf="!disabled"
                        [tabindex]="i === 0 ? 0 : -1"
                        [id]="id + '-tag-list-tag-' + i + '-remove-action'"
                        type="button"
                        class="sh-tag__button"
                        (click)="removeTag(tag.value)"
                        (keydown.enter)="onEditMode(i, tag.value)"
                        (keydown.space)="onEditMode(i, tag.value)"
                        (keyup.delete)="removeTag(tag.value)"
                        (keyup.backspace)="removeTag(tag.value)"
                        (focus)="onTagFocus()"
                    >
                        <svg sh-icon [name]="'delete'" [size]="sizes.SMALL" [addDefaultClasses]="false" aria-hidden="true" class="sh-tag__icon"></svg>
                    </button>
                </li>
            } @else {
                <input
                    shDynamicResize
                    type="text"
                    class="sh-tag sh-tag-list__item test"
                    [formControl]="tagEditFormControl"
                    [shAutoFocus]="true"
                    [shClickOutsideFocusEvent]="'focusin'"
                    (shClickOutside)="onSubmitTagEditChange()"
                    (keyup.escape)="onEscape()"
                    (keyup.enter)="onSubmitTagEditChange()"
                />
            }
        }
        <li *ngIf="styling.style === formTagListStyle.Embedded" class="sh-form-tag-list__inline-input">
            <ng-container *ngTemplateOutlet="inputField"></ng-container>
            <div class="sh-form-tag-list__inline-input__highlight"></div>
        </li>
    </ul>
</ng-template>

<ng-template #suggestions>
    <ng-container *ngIf="suggestions$ | async as suggestions">
        <div *ngIf="suggestions.length !== 0" class="sh-droppanel sh-form-tag-list__droppanel" [ngClass]="droppanelStyle" [class.-sh-is-open]="droppanelOpen">
            <ul class="sh-droppanel__list">
                <li *ngFor="let suggestion of suggestions" class="sh-droppanel__list__item">
                    <button #suggestionItem tabindex="-1" type="button" class="sh-droppanel__list-action"
                            [class.-sh-unhoverable]="suggestionFocusIndex > -1" (click)="onSelect(suggestion)">
                        <div class="sh-droppanel__list-action__label">{{ suggestion }}</div>
                    </button>
                </li>
            </ul>
        </div>
    </ng-container>
</ng-template>
